"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _FiltersMobile = _interopRequireDefault(require("./FiltersMobile")),
    _Input = _interopRequireDefault(require("../../../../Input")),
    _Button = _interopRequireDefault(require("../../../../Button")),
    _Dropdown = _interopRequireDefault(require("../../../../Dropdown")),
    _Icon = _interopRequireDefault(require("../../../../Icon")),
    _ListViewSelector = _interopRequireDefault(require("./ListViewSelector")),
    _viewTypes = require("../../../constants/viewTypes"),
    _Text = _interopRequireDefault(require("../../../../Text")),
    _filters = require("../styles/filters");

require("../styles/_filters.scss");

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var Filters = function (a) {
  function b() {
    var a;
    return (0, _classCallCheck2["default"])(this, b), a = c.call(this), a.onSelectFilter = (0, _lodash["default"])(function (b) {
      return function (c) {
        var d = a.props.setSelectedFilters;
        d((0, _defineProperty2["default"])({}, b, c || null));
      };
    }), a.toggleVisibility = function () {
      return a.setState(function (a) {
        var b = a.filtersVisible;
        return {
          filtersVisible: !b
        };
      });
    }, a.handleResetFilters = function () {
      var b = a.props.resetFilters;
      b(), a.toggleVisibility();
    }, a.state = {
      filtersVisible: !1
    }, a;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this,
          b = this.props,
          c = b.isMobile,
          d = b.onSearch,
          e = b.bothViewsAvailable,
          f = b.view,
          g = b.onChangeView,
          h = b.selectedFilters,
          i = b.setSelectedFilters,
          j = b.filters,
          k = b.filtersRightAddon,
          l = b.totalResults,
          m = b.numberOfItems,
          n = b.searchTerm,
          o = b.customSearchText,
          p = this.state.filtersVisible,
          q = Object.keys(h).filter(function (a) {
        return h[a].value !== j[a][0].value;
      }).length;
      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
        className: (0, _classnames["default"])("filters__container", (0, _filters.FILTERS_CONTAINER)({
          isMobile: c
        }))
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])("filters__search", {
          "filters__search--mobile": c
        })
      }, _react["default"].createElement(_Input["default"], {
        id: "filter-search",
        className: (0, _classnames["default"])("filters__input", (0, _filters.SEARCH_CLS)({
          bothViewsAvailable: e,
          isMobile: c
        })),
        prefix: "search",
        onChange: d,
        clearButton: _react["default"].createElement(_Icon["default"], {
          name: "close",
          size: 10,
          color: "regent"
        }),
        placeholder: "Search"
      }), (n || o) && _react["default"].createElement(_Text["default"], {
        label: !0,
        noMargin: !0
      }, "".concat(l || m || 0, " results found"))), c ? _react["default"].createElement("div", {
        className: (0, _classnames["default"])("filters__mobile", _filters.FILTERS_MOBILE)
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])("filters__toggle-btn", _filters.FILTER_TOGGLE_CONTAINER)
      }, _react["default"].createElement(_Button["default"], {
        onClick: this.toggleVisibility,
        type: "SECONDARY",
        className: (0, _classnames["default"])("filters__toggle-btn", _filters.FILTER_TOGGLE)
      }, "Filter"), _react["default"].createElement(_Text["default"], {
        darkTheme: !0,
        caption: !0,
        className: (0, _filters.BADGE)(q)
      }, q)), _react["default"].createElement("div", {
        className: (0, _classnames["default"])("filters__mobile__icons-container", _filters.FILTERS_MOBILE_ICONS_CONTAINER)
      }, _react["default"].createElement(_ListViewSelector["default"], {
        view: f,
        onChangeView: g,
        bothViewsAvailable: e,
        isMobile: c
      }))) : _react["default"].createElement("div", {
        className: (0, _classnames["default"])("filters__right-content", _filters.RIGHT_CONTENT_CLS)
      }, Object.keys(j).map(function (b) {
        return Array.isArray(j[b]) ? _react["default"].createElement(_Dropdown["default"], {
          key: b,
          id: "all-filter-dropdown",
          className: (0, _classnames["default"])("filters__dropdown", _filters.DROPDOWN_CLS),
          options: j[b],
          defaultValue: h[b] || j[b][0],
          onChange: a.onSelectFilter(b),
          fontSize: 12,
          type: "BUTTON"
        }) : _react["default"].createElement(_Dropdown["default"], (0, _extends2["default"])({
          key: b,
          id: "all-filter-dropdown",
          className: (0, _classnames["default"])("filters__dropdown", _filters.DROPDOWN_CLS),
          options: j[b].options || [],
          onChange: a.onSelectFilter(b),
          fontSize: 12,
          type: "BUTTON"
        }, j[b]));
      }), _react["default"].createElement(_ListViewSelector["default"], {
        view: f,
        onChangeView: g,
        bothViewsAvailable: e
      })), k), c ? _react["default"].createElement(_FiltersMobile["default"], {
        setSelectedFilters: i,
        resetFilters: this.handleResetFilters,
        selectedFilters: h,
        visible: p,
        toggleVisibility: this.toggleVisibility,
        filters: j
      }) : null);
    }
  }]), b;
}(_react.Component),
    _default = Filters;

exports["default"] = _default;